import React from 'react'

import { ISectionHeaderIndexProps } from './interface'

import './styles.scss'

const SectionHeader: React.FC<ISectionHeaderIndexProps> = ({
  title,
  selectedOrganizationName,
  children,
  buttons,
  className = '',
}) => {
  return (
    <div className={`section-header ${className}`}>
      <div className="section-header__left">
        <div className={`section-header__title ${className}__title`}>
          {title} {selectedOrganizationName ? `- ${selectedOrganizationName}` : null}
        </div>
        <div className={`section-header__title ${className}__title`}>{buttons}</div>
      </div>
      <div className="section-header__right">{children}</div>
    </div>
  )
}

export default SectionHeader
